export default "__VITE_ASSET__Ky0Wtfku__"